import {
  PERMISSION_CREATE,
  PERMISSION_OBJ_COOPERATIVE,
  PERMISSION_OBJ_FARM,
  PERMISSION_OBJ_FARMER,
  PERMISSION_OBJ_FARMER_PLOT,
  PERMISSION_READ,
  PERMISSION_UPDATE,
} from '@/constants/permissions';

import { Farmers } from './table';
import { CreateFarmersFromExcelByType } from './create-from-excel-by-type';
import { FarmerForm } from './form';
import { FarmerView } from './view';

export const states = [
  {
    name: 'base-layout.farmers',
    url: '/farmers',
    component: Farmers,
    data: {
      requiresAuth: true,
      permissions: [
        [PERMISSION_OBJ_FARMER, PERMISSION_READ],
        [PERMISSION_OBJ_FARM, PERMISSION_READ],
      ],
    },
  },
  {
    name: 'base-layout.farmers.create',
    url: '/new',
    component: FarmerForm,
    data: {
      requiresAuth: true,
      permissions: [[PERMISSION_OBJ_FARMER, PERMISSION_CREATE]],
    },
  },
  {
    name: 'base-layout.farmers.edit',
    url: '/:farmerId/edit',
    component: FarmerForm,
    data: {
      requiresAuth: true,
      permissions: [[PERMISSION_OBJ_FARMER, PERMISSION_UPDATE]],
    },
  },
  {
    name: 'base-layout.farmers.view',
    url: '/:farmerId/view',
    component: FarmerView,
    data: {
      requiresAuth: true,
      permissions: [
        [PERMISSION_OBJ_FARMER, PERMISSION_READ],
        [PERMISSION_OBJ_FARMER_PLOT, PERMISSION_READ],
        [PERMISSION_OBJ_FARM, PERMISSION_READ],
      ],
    },
  },
  {
    name: 'base-layout.farmers.create-from-excel-by-type',
    url: '/create-from-excel',
    component: CreateFarmersFromExcelByType,
    data: {
      requiresAuth: true,
      permissions: [
        [PERMISSION_OBJ_FARMER, PERMISSION_CREATE],
        [PERMISSION_OBJ_FARMER, PERMISSION_UPDATE],
        [PERMISSION_OBJ_COOPERATIVE, PERMISSION_READ],
      ],
    },
  },
];
